module.exports = __webpack_public_path__ + "img/raffle-draw-icon.f9b797a4.svg";